@for (team of teams; track team) {
  <app-roles-list-item
    [team]="team"
    [padding]="itemPadding"
    [avatarBackgroundSize]="avatarBackgroundSize"
    [avatarSize]="avatarSize"
    (role)="handleRoleClicked($event)"
  ></app-roles-list-item>
}
